<template>

  <svg t="1728367702589" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg"
       p-id="4250" width="200" height="200" xmlns:xlink="http://www.w3.org/1999/xlink">
    <path
        d="M495.274667 170.453333a21.333333 21.333333 0 0 1 33.450666 0L704.533333 392.533333a21.333333 21.333333 0 0 0 25.130667 6.368l171.392-73.450666a21.333333 21.333333 0 0 1 29.301333 23.946666l-94.912 457.28A85.333333 85.333333 0 0 1 751.893333 874.666667H272.106667a85.333333 85.333333 0 0 1-83.552-67.989334l-94.912-457.28a21.333333 21.333333 0 0 1 29.290666-23.946666l171.402667 73.450666a21.333333 21.333333 0 0 0 25.130667-6.368l175.808-222.08z"
         p-id="4251"></path>
  </svg>

</template>

<script lang="ts">
export default {
  name: 'memberIcon'
}
</script>